export const EXPAND_NEWSLETTER_WIDGET_EVENT = 'EXPAND_NEWSLETTER_WIDGET_EVENT'
